let events = [];

$.getJSON('events.json', (data) => {
	for (let index = 0; index < data.events.length; index++) {
		events.push({'href': data.events[index].href,
			'title': data.events[index].title,
			'class': data.events[index].class,
			'img': data.events[index].img,
			'Date': new Date(data.events[index].Date)});
	}
})
	.done(() => {
		let countDate;

		if ($('#datepicker').length) {
			$('#datepicker').datepicker({
				beforeShowDay: (date) => {
					let result = [true, '', null];

					let classes = '';

					$.grep(events, (event) => {
						if (event.Date.valueOf() === date.valueOf()) {
							classes = event.class;
							result = [true, classes, null];
						}
					});

					return result;
				},
				onSelect: (dateText) => {
					let date;

					let selectedDate = new Date(dateText);

					let i = 0;

					let event = null;

					while (i < events.length && !event) {
						date = events[i].Date;

						if (selectedDate.valueOf() === date.valueOf()) {
							event = events[i];
						}
						i++;
					}
					if (event) {
						window.open(
							event.href,
							'_blank'
						);
					}
				},
			});

			countDate = $('#datepicker').datepicker('getDate').getMonth();
		}

		let currentMounthEvents = [];

		let $slider = $('.meetups__slider');

		function formatDate(date) {
			let day = date.getDate();

			let monthIndex;

			if (date.getMonth() + 1 < 10) {
				monthIndex = `0${date.getMonth() + 1}`;
			} else {
				monthIndex = date.getMonth() + 1;
			}

			let year = date.getFullYear();

			return `${day}.${monthIndex}.${year}`;
		}

		function initEventsCarousel(array) {
			$('.meetups__current-month').text($('.ui-datepicker-month').text());
			$('.meetups__current-year').text($('.ui-datepicker-year').text());

			$.grep(events, (event) => {
				if (event.Date.getMonth() === countDate) {
					array.push(event);
				}
			});

			for (let index = 0; index < array.length; index++) {
				const element = array[index];

				const date = element.Date;

				const $event = `<a class="meetups__item-slider ${element.class}" target="_blank" href="${element.href}">
								<div class="meetups__info-slider">
									<div>
										<div class="meetups__title-slider">${element.title}</div>
										<div class="meetups__date-slider">${formatDate(date)}</div>
									</div>
								</div><img src="${element.img}" alt=""></a>`;

				$slider.append($event);
			}

			if (innerWidth < 1025) {
				$slider.slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: false,
					dots: false,
					arrows: false,
				});
			} else {
				$slider.addClass('is-none-carousel');
			}
		}

		function removeEvents() {
			$('.meetups__item-slider').remove();

			if (innerWidth < 1024) {
				$slider.slick('unslick');
				$slider.removeClass('is-none-carousel');
			}
		}

		if ($('#datepicker').length) {
			initEventsCarousel(currentMounthEvents);

			$('.meetups__button-prev').on('click', () => {
				$(document).find('.ui-datepicker-prev').trigger('click');
			});

			$('.meetups__button-next').on('click', () => {
				$(document).find('.ui-datepicker-next').trigger('click');
			});

			$(document).on('click', '.ui-datepicker-next', '.next-date', () => {
				let newCurrentEvents = [];

				removeEvents();
				countDate += 1;
				initEventsCarousel(newCurrentEvents);
			});

			$(document).on('click', '.ui-datepicker-prev', '.prev-date', () => {
				let newCurrentEvents = [];

				removeEvents();
				countDate -= 1;
				initEventsCarousel(newCurrentEvents);
			});
		}
	});

if ($('.event__slider').length) {
	$('.event__slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: false,
		dots: false,
		arrows: true,
	});
}
